(function () {

  const CAMPAIGN_START = new Date('2026-09-28T00:00:00-03:00');
  const CAMPAIGN_END   = new Date('2026-10-31T23:59:59-03:00');

  function isCampaignActive() {
    const now = new Date();
    return now >= CAMPAIGN_START && now <= CAMPAIGN_END;
  }

  const rootUrl = window.Shopify?.routes?.root || '/';

  function cartUrl(path) {
    const cleanRoot = rootUrl.endsWith('/') ? rootUrl : `${rootUrl}/`;
    return `${cleanRoot}${path}`;
  }

  function isCartRequest(url) {
    if (!url) return false;
    const s = String(url);
    return s.includes('/cart/add') || s.includes('/cart/change') || s.includes('/cart/update') || s.includes('/cart/clear');
  }

  async function getCart() {
    const response = await fetch(cartUrl('cart.js'), {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Não foi possível buscar o carrinho.');
    return response.json();
  }

  function createCampaign(modalId, options) {
    const modal = document.getElementById(modalId);
    if (!modal) return null;

    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    const threshold    = Number(modal.dataset.threshold || options.threshold);
    const variantId    = Number(modal.dataset.giftVariantId || options.variantId);
    const storageKey   = modal.dataset.storageKey || options.storageKey;
    const campaignName = options.campaignName;

    const redeemButton = modal.querySelector('[data-ap-gift-redeem]');
    const closeButtons = modal.querySelectorAll('[data-ap-gift-close]');

    let isEvaluating = false;
    let isRemoving   = false;
    let watcherId    = null;

    if (!variantId) {
      console.warn(`[Anna Prata Gift] Variant ID não configurado para ${modalId}.`);
      return null;
    }

    function getGiftLineItem(cart) {
      return cart.items.find(item => Number(item.variant_id) === variantId);
    }

    function forceModalStyles() {
      Object.assign(modal.style, {
        position: 'fixed', inset: '0', zIndex: '2147483647',
        display: 'grid', placeItems: 'center',
        opacity: '1', visibility: 'visible', pointerEvents: 'auto'
      });
      const overlay = modal.querySelector('.ap-gift-campaign__overlay');
      const card    = modal.querySelector('.ap-gift-campaign__card');
      if (overlay) Object.assign(overlay.style, { position: 'absolute', inset: '0', zIndex: '1' });
      if (card)    Object.assign(card.style,    { position: 'relative', zIndex: '2', display: 'block', opacity: '1', visibility: 'visible' });
    }

    function openModal() {
      if (!isCampaignActive()) return;
      if (sessionStorage.getItem(`${storageKey}:shown`) === 'true') return;
      modal.hidden = false;
      requestAnimationFrame(() => {
        modal.classList.add('is-visible');
        forceModalStyles();
      });
      sessionStorage.setItem(`${storageKey}:shown`, 'true');
      console.info(`[Anna Prata Gift] Modal ${modalId} exibido.`);
    }

    function closeModal() {
      modal.classList.remove('is-visible');
      Object.assign(modal.style, { opacity: '0', visibility: 'hidden', pointerEvents: 'none' });
      setTimeout(() => { modal.hidden = true; }, 260);
    }

    function startWatcher() {
      if (watcherId) return;
      watcherId = setInterval(() => evaluateCart('watcher'), 5000);
    }

    async function removeGift(giftItem, source) {
      if (!giftItem || isRemoving) return;
      isRemoving = true;
      try {
        const response = await fetch(cartUrl('cart/change.js'), {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: giftItem.key || giftItem.variant_id, quantity: 0 })
        });
        if (!response.ok) throw new Error(await response.text());
        sessionStorage.removeItem(`${storageKey}:shown`);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
        console.info(`[Anna Prata Gift] Presente ${modalId} removido.`);
      } catch (e) {
        console.warn(`[Anna Prata Gift] Erro ao remover presente ${modalId}:`, e);
      } finally {
        isRemoving = false;
      }
    }

    async function evaluateCart(source) {
      if (isEvaluating) return;
      isEvaluating = true;
      try {
        const cart = await getCart();

        const cartSubtotal = cart.items.reduce((total, item) => {
          if (Number(item.variant_id) === variantId) return total;
          return total + item.final_line_price;
        }, 0);

        const cartDiscount = cart.cart_level_discount_applications
          ? cart.cart_level_discount_applications.reduce((t, d) => t + (d.total_allocated_amount || 0), 0)
          : 0;

        const total         = cartSubtotal - cartDiscount;
        const reachedThresh = total >= threshold;
        const giftItem      = getGiftLineItem(cart);
        const hasGift       = Boolean(giftItem);

        console.info(`[Anna Prata Gift] ${modalId}:`, { origem: source, total, threshold, reachedThresh, hasGift });

        if (hasGift && !reachedThresh) {
          await removeGift(giftItem, source);
          return;
        }

        if (hasGift) {
          sessionStorage.setItem(`${storageKey}:shown`, 'true');
        }

      } catch (e) {
        console.warn(`[Anna Prata Gift] Erro ao avaliar ${modalId}:`, e);
      } finally {
        isEvaluating = false;
      }
    }

    function scheduleEvaluate(source) {
      setTimeout(() => evaluateCart(source), 600);
      setTimeout(() => evaluateCart(`${source}:final`), 2000);
    }

    async function redeemGift() {
      if (!redeemButton) return;
      redeemButton.disabled = true;
      redeemButton.textContent = 'RESGATANDO...';

      try {
        const cart = await getCart();

        const cartSubtotal = cart.items.reduce((total, item) => {
          if (Number(item.variant_id) === variantId) return total;
          return total + item.final_line_price;
        }, 0);
        const cartDiscount = cart.cart_level_discount_applications
          ? cart.cart_level_discount_applications.reduce((t, d) => t + (d.total_allocated_amount || 0), 0)
          : 0;
        const total = cartSubtotal - cartDiscount;

        if (total < threshold) {
          redeemButton.textContent = 'VALOR MÍNIMO NÃO ATINGIDO';
          setTimeout(() => {
            redeemButton.disabled = false;
            redeemButton.textContent = 'RESGATAR PRESENTE';
          }, 1800);
          return;
        }

        if (getGiftLineItem(cart)) {
          redeemButton.textContent = 'PRESENTE JÁ RESGATADO';
          setTimeout(() => closeModal(), 1500);
          return;
        }

        const response = await fetch(cartUrl('cart/add.js'), {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1, properties: { _campanha: campaignName } })
        });

        if (!response.ok) {
          const err = await response.text();
          console.warn(`[Anna Prata Gift] Shopify recusou ${modalId}:`, err);
          throw new Error(err);
        }

        const updatedCart = await getCart();
        if (!getGiftLineItem(updatedCart)) throw new Error('Presente não apareceu no carrinho.');

        redeemButton.textContent = 'PRESENTE ADICIONADO';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
        window.dispatchEvent(new CustomEvent('ap:gift-added'));

        modal.classList.remove('is-visible');
        Object.assign(modal.style, { opacity: '0', visibility: 'hidden', pointerEvents: 'none' });

        setTimeout(() => {
          modal.hidden = true;
          redeemButton.disabled = false;
          redeemButton.textContent = 'RESGATAR PRESENTE';
          const cartToggle = document.querySelector('[aria-controls="cart-drawer"]');
          if (cartToggle) cartToggle.click();
        }, 320);

      } catch (e) {
        console.warn(`[Anna Prata Gift] Erro ao resgatar ${modalId}:`, e);
        redeemButton.disabled = false;
        redeemButton.textContent = 'TENTAR NOVAMENTE';
      }
    }

    closeButtons.forEach(btn => btn.addEventListener('click', closeModal));
    if (redeemButton) redeemButton.addEventListener('click', redeemGift);

    document.addEventListener('cart:updated', () => scheduleEvaluate('cart:updated'));
    document.addEventListener('cart:refresh', () => scheduleEvaluate('cart:refresh'));
    document.addEventListener('cart:change',  () => scheduleEvaluate('cart:change'));

    document.addEventListener('click', event => {
      const hit =
        event.target.closest('button[name="add"]') ||
        event.target.closest('[data-cart-add]') ||
        event.target.closest('form[action*="/cart/add"]') ||
        event.target.closest('cart-drawer button') ||
        event.target.closest('line-item-quantity button') ||
        event.target.closest('quantity-selector button');
      if (hit) { scheduleEvaluate('click-cart-action'); startWatcher(); }
    }, true);

    document.addEventListener('submit', event => {
      if (event.target?.matches('form[action*="/cart/add"]')) {
        scheduleEvaluate('submit-cart-add'); startWatcher();
      }
    }, true);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => { evaluateCart('DOMContentLoaded'); startWatcher(); });
    } else {
      evaluateCart('init-ready');
      startWatcher();
    }

    return {
      evaluateCart: () => evaluateCart('console'),
      openModal:    () => { sessionStorage.removeItem(`${storageKey}:shown`); openModal(); },
      closeModal,
      clearSession: () => {
        sessionStorage.removeItem(`${storageKey}:shown`);
        startWatcher();
        console.info(`[Anna Prata Gift] Sessão ${modalId} limpa.`);
      }
    };
  }

  const originalFetch = window.fetch;
  window.fetch = async function () {
    const url = arguments[0]?.url || arguments[0];
    const response = await originalFetch.apply(this, arguments);
    if (isCartRequest(url)) {
      setTimeout(() => { runModalQueue(); }, 600);
      setTimeout(() => { runModalQueue(); }, 2000);
    }
    return response;
  };

  const originalXHROpen = XMLHttpRequest.prototype.open;
  const originalXHRSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._apGiftUrl = url;
    return originalXHROpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    this.addEventListener('loadend', function () {
      if (isCartRequest(this._apGiftUrl)) {
        setTimeout(() => { runModalQueue(); }, 600);
        setTimeout(() => { runModalQueue(); }, 2000);
      }
    });
    return originalXHRSend.apply(this, arguments);
  };

  window.AP_GIFT_IMA = createCampaign('ap-gift-campaign-1', {
    threshold:    39900,
    variantId:    50411674501377,
    storageKey:   'ap-gift-ima-primavera-2026',
    campaignName: 'ima-de-primavera-outubro-2026'
  });

  window.AP_GIFT_LENCO = createCampaign('ap-gift-campaign-2', {
    threshold:    100000,
    variantId:    50411184423169,
    storageKey:   'ap-gift-lenco-exclusivo-2026',
    campaignName: 'lenco-exclusivo-outubro-2026'
  });

  window.AP_GIFT_CAMPAIGN = {
    clearSession: function () {
      if (window.AP_GIFT_IMA)   window.AP_GIFT_IMA.clearSession();
      if (window.AP_GIFT_LENCO) window.AP_GIFT_LENCO.clearSession();
    },
    status: async function () {
      const cart = await getCart();
      console.info('[Anna Prata Gift] Carrinho:', {
        total: cart.total_price,
        itens: cart.items.map(i => ({ title: i.title, variant_id: i.variant_id, quantity: i.quantity }))
      });
    }
  };

  // ── Fila de modais — exibe um por vez com prioridade ──
  let queueRunning = false;

  async function runModalQueue() {
    if (queueRunning) return;
    queueRunning = true;

    try {
      const cart = await getCart();

      const subtotal = cart.items.reduce((total, item) => {
        const isGift = [50411674501377, 50411184423169].includes(Number(item.variant_id));
        return isGift ? total : total + item.final_line_price;
      }, 0);

      const discount = cart.cart_level_discount_applications
        ? cart.cart_level_discount_applications.reduce((t, d) => t + (d.total_allocated_amount || 0), 0)
        : 0;

      const total = subtotal - discount;

      const imaInCart   = cart.items.some(i => Number(i.variant_id) === 50411674501377);
      const lencoInCart = cart.items.some(i => Number(i.variant_id) === 50411184423169);

      /* ── Limpa sessão se presente foi removido e threshold não atingido ── */
      if (!imaInCart && total < 39900) {
        sessionStorage.removeItem('ap-gift-ima-primavera-2026:shown');
      }
      if (!lencoInCart && total < 100000) {
        sessionStorage.removeItem('ap-gift-lenco-exclusivo-2026:shown');
      }

      const imaShown   = sessionStorage.getItem('ap-gift-ima-primavera-2026:shown') === 'true';
      const lencoShown = sessionStorage.getItem('ap-gift-lenco-exclusivo-2026:shown') === 'true';

      if (!isCampaignActive()) return;

      /* ── Prioridade 1: Ímã (a partir de R$ 399) ── */
      if (total >= 39900 && !imaInCart && !imaShown) {
        setTimeout(() => {
          window.AP_GIFT_IMA && window.AP_GIFT_IMA.openModal();
        }, 2000);
        return;
      }

      /* ── Prioridade 2: Lenço (somente se Ímã já foi resgatado E total >= R$ 1.000) ── */
      if (total >= 100000 && imaShown && !lencoInCart && !lencoShown) {
        setTimeout(() => {
          window.AP_GIFT_LENCO && window.AP_GIFT_LENCO.openModal();
        }, 4000);
        return;
      }

    } catch (e) {
      console.warn('[Anna Prata Gift] Erro na fila de modais:', e);
    } finally {
      queueRunning = false;
    }
  }

  setInterval(runModalQueue, 5000);
  setTimeout(runModalQueue, 1000);

  document.addEventListener('cart:updated', () => setTimeout(runModalQueue, 800));
  document.addEventListener('cart:refresh', () => setTimeout(runModalQueue, 800));
  document.addEventListener('cart:change',  () => setTimeout(runModalQueue, 800));

})();